<style lang="less" scoped>
.Message {position: relative;width: 600px;height: 200px;text-align: left;margin-top:-20px;margin-left:-40px;margin-right:40px;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;}
ul {list-style: none;height: 300px;overflow: hidden;}
li {display:flex;margin-top:5px;margin-bottom:5px;width: 600px;border-bottom: 2px solid #f6f6f6;line-height: 33px;}
.title{float:left;width:350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.type{position:absolute;right: 5px;}
</style>

<!--李旭 2021.5.25
    该卡片组件使用场景：第一部分显示第一条新闻的图片、内容及时间；第二部分按顺序依次显示每条新闻的标题和时间
    鼠标放在图片上，图片会放大，
    鼠标点击新闻的图片或标题，将 相应的对象 传递给父组件 -->
<template>
  <div class="Message">
    <ul class="list">
      <li v-for="(item, index) in messageList" :key="index" @click="clickNewsMessage(item)">
        <span class="title"> {{ item.title }} </span>
        <span class="type">{{item.type}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['messageList'],
  data()
  {
    return {
    }
  },
  methods: {
    // 点击公司名称，将 整个公司对象 传递给父组件
    clickNewsMessage(item)
    {
      this.$emit('clickNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Message.vue